module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIiIGhlaWdodD0iMTIiIHZpZXdCb3g9IjAgMCAxMiAxMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4NCjxnIGlkPSJQcm9wZXJ0eSAxPSYjMjMxOyYjMTg2OyYjMTYyOyYjMjMxOyYjMTM3OyYjMTQwOyI+DQo8cGF0aCBpZD0iVmVjdG9yIiBkPSJNOCAwSDRDMi44OTU0MyAwIDIgMC44OTU0MyAyIDJWMTBDMiAxMS4xMDQ2IDIuODk1NDMgMTIgNCAxMkg4QzkuMTA0NTcgMTIgMTAgMTEuMTA0NiAxMCAxMFYyQzEwIDAuODk1NDMgOS4xMDQ1NyAwIDggMFoiIGZpbGw9IiNFODUwM0EiLz4NCjwvZz4NCjwvc3ZnPg0K"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/details/event/22.svg
// module id = 1XQs
// module chunks = 0